import React, {useEffect, useState, useRef, useContext} from 'react';

import "./OptionMenuCollection.scss";
import SaveCollectionModal from "../modals/SaveCollectionModal";
import {ModalContext} from "../ModalContext";
import ProofModal from "../modals/ProofModal";
import {
  collectionDelete,
  assignToCollection,
  copyToCollectionUnsaved,
  unassignFromCollection
} from "../../store/actions/collections";
import {useDispatch, useSelector} from "react-redux";
import {useDashboardState} from "../DashboardContext";
import {showToast} from "../../utils/helpers";
import {getSelection} from "../../utils/builder/IScheduleLogic";
import {tabType} from "../../utils/data";

const OptionMenuCollection = ({
      isOpenMenuCollection,
      closeOptionMenu,
      menuCollectionButtonPosition,
      infoAboutCollection,
    }) => {

  const { handleModal } = useContext(ModalContext);

  const { tabs } = useSelector((state) => state.table);

  const { setIsTableHidden } = useDashboardState();

  const optionMenu = useRef();

  const dispatch = useDispatch();

  const [menuCollectionPosition, setMenuCollectionPosition] = useState(null);
  const [isAssignSelectionButton, setAssignSelectionButton] = useState(null);

  useEffect(async () => {
    const optionMenuClientRect = optionMenu.current?.getBoundingClientRect();
    const heightWindow = document.body.scrollHeight;

    const clientX = menuCollectionButtonPosition?.right + 10;
    let clientY = menuCollectionButtonPosition?.top - 20;

    if(heightWindow - menuCollectionButtonPosition?.y < optionMenuClientRect?.height) {
      clientY =  clientY - optionMenuClientRect.height + 60;
    }

    setMenuCollectionPosition({clientX, clientY});

    const selectionElementsOnViewer = await getSelection();
    setAssignSelectionButton(!!selectionElementsOnViewer.length)

  }, [isOpenMenuCollection]);

  useEffect(() => {

    const checkElement = (event) => {
      const currentElement = event.target;
      const optionMenuElement = optionMenu.current;

      if(!optionMenuElement?.contains(currentElement)) {
        closeOptionMenu();
      }
    }

    document.addEventListener('click', (event) => checkElement(event));

    return(
      document.removeEventListener('click', (event) => checkElement(event))
    )
  }, [isOpenMenuCollection]);

  const handleCancel = () => {
    handleModal(null, true);
  };

  const openEditCollection = () => {
    handleModal(
      <SaveCollectionModal type={"edit"} folderInfo={infoAboutCollection} />
    );
    closeOptionMenu();
  }

  const deleteCollection = async () => {

    try {
      await dispatch(collectionDelete({tabs, title: infoAboutCollection.title, folder: infoAboutCollection.folder, id: infoAboutCollection.collection.creationTime}));
      showToast(true,"Selection set was deleted");
    } catch (error) {
      showToast(false, error);
    }

    handleCancel();
  }

  const openProofModal = () => {
    handleModal(
      <ProofModal proofCallback={deleteCollection} cancelButtonText={"Cancel"} proofButtonText={"Yes, delete"}>
        <div>You want to delete <b>“{infoAboutCollection.title}”</b> collection?</div>
      </ProofModal>
    );
    closeOptionMenu();
  }

  const assignElements = () => {
    try {
      dispatch(assignToCollection({title: infoAboutCollection.title, folder: infoAboutCollection.folder, id: infoAboutCollection.collection.creationTime}));
      showToast(true,`Assigned to ${infoAboutCollection.title}`);
    } catch (error) {
      showToast(false, "Something went wrong");
    }
    closeOptionMenu();
  }

  const unassignElements = () => {
    dispatch(unassignFromCollection({...infoAboutCollection, type: tabType.saved, name: infoAboutCollection.title, id: infoAboutCollection.collection.creationTime}));
    closeOptionMenu();
  }

  return (
    <div className="option-menu-collection-wrapper">
      {
        isOpenMenuCollection &&
        <div className="option-menu-collection" ref={optionMenu}
             style={{top: menuCollectionPosition?.clientY + "px", left: menuCollectionPosition?.clientX + "px"}}>
          <div className="option" onClick={openEditCollection}>Edit</div>
          {
            isAssignSelectionButton &&
            <>
              <div className="option" onClick={assignElements}>Assign selection</div>
              <div className="option" onClick={unassignElements}>Unassign selection</div>
            </>
          }
          <div className="option_red" onClick={openProofModal}>Delete</div>
        </div>
      }
    </div>
  );
};

export default OptionMenuCollection;